// extracted by mini-css-extract-plugin
export default {"form":"invite-post-join-modal_form__gBbWv","footer":"invite-post-join-modal_footer__I+wCz"};